import { createSlice } from '@reduxjs/toolkit';
import { ProjectTemplate, ProjectTemplateStore } from '../types';
import { allocationSlice } from './allocation';
import { automationSlice } from './automations';
import { dynamicTemplateSlice } from './dynamic-template';
import { projectPhaseSlice } from './project-phase';
import { spaceSlice } from './space';
import { tableSlice } from './table';
import { taskSlice } from './task';
import { templateSlice } from './template';
import { variablesSlice } from './variables';

const INITIAL_STATE: ProjectTemplateStore = {
  data: {
    new: {
      error: null,
      loading: true,
      spaceSetup: 'YET_TO_START',
      projectPhases: {},
      template: {} as ProjectTemplate,
      tasks: {},
      spaceList: {},
      dynamicConditions: {},
      placeholders: {},
      allocations: {},
      allocatedMembers: {
        users: [],
        teams: [],
      },
    },
  },
  activeRecord: undefined,
  activeId: 'new',
  projectToTemplate: false,
  activeSpaceId: null,
  activeSpaceTabId: null,
};

export const projectTemplateSlice = createSlice({
  initialState: INITIAL_STATE,
  name: '@@TEMPLATES/PROJECT',
  reducers: {
    ...templateSlice,
    ...projectPhaseSlice,
    ...taskSlice,
    ...spaceSlice,
    ...tableSlice,
    ...dynamicTemplateSlice,
    ...allocationSlice,
    ...variablesSlice,
    ...automationSlice,
  },
});

export const {
  createProjectTemplateProjectPhase,
  createProjectTemplateTask,
  setProjectTemplateActiveRecord,
  createProjectTemplateSubTask,
  updateProjectTemplateProjectPhase,
  updateProjectTemplateProjectPhases,
  updateProjectTemplateTask,
  updateProjectTemplateTasks,
  updateProjectTemplateStartdayDuration,
  deleteProjectTemplateProjectPhase,
  deleteProjectTemplateTask,
  deleteProjectTemplateSubTask,
  createProjectTemplateSpace,
  updateProjectTemplateSpace,
  deleteProjectTemplateSpace,
  addProjectTemplateTaskDependency,
  addProjectTemplatePhaseDependency,
  setupSpacesOnProjectTemplate,
  setupSpacesOnProjectTemplateInProgress,
  setupSpacesOnProjectTemplateComplete,
  setupSpaceTabsOnSpaces,
  shiftStartDayOfProjectPhase,
  updateSpaceTabInSpaces,
  updateJiraMappingInTemplate,
  updateDynamicConditions,
  setDynamicConditions,
  makeDateShiftsForProjectPhases,
  makeDateShiftsForTasks,
  bulkActions,
  setAllocatedMembers,
  setConditionalVariables: setConditionalVariablesInProjectTemplate,
  removeConditionalVariables,
  updateAutomationById,
  updateAllAutomations,
  toggleEnabledStateForAutomationById,
  createAutomationForSource,
} = projectTemplateSlice.actions;
